<div id="app-emails-declinio-proposta">
  <!-- Email Declinio da Proposta -->
  <section class="mb-5" *ngIf="mostrarEmailDeclinado">
    <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
      Email de Declinio da Proposta - Declinado {{ dataDeclinio }} às
      {{ horaDeclinio }}
    </h3>
    <div>
      <title>Proposta Cancelada</title>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap" rel="stylesheet" />
    </div>
    <div style="margin: 0; padding: 0">
      <table width="100%" cellpadding="0" cellspacing="0">
        <tr>
          <td align="center">
            <table
              cellpadding="0"
              cellspacing="0"
              style="background-color: #f2f2f2; padding: 20px; width: 100%; max-width: 600px">
              <tr>
                <td align="center" style="padding: 20px 0">
                  <img
                    src="https://geia.com.br/assets/app-assets/images/logo/logo-b-geia.png"
                    width="120"
                    alt="Logo Geia" />
                </td>
              </tr>
              <tr>
                <td style="padding: 10px 25px; font-size: 14px; color: #000">
                  <p>São Paulo, {{ dataDeclinio }}</p>
                  <p>
                    À
                    <br />
                    {{ nomeTitular }}
                  </p>
                  <br />
                  <p>Prezado Sr(a) {{ nomeTitular }}</p>
                  <br />
                  <p>
                    <strong>REF: PROPOSTA CANCELADA - PROPOSTA DE ADESÃO nº {{ codigoProposta }}.</strong>
                  </p>
                  <br />
                  <p>
                    Informamos que a proposta acima citada, referente à(o) beneficiário(a)
                    <strong>{{ nomeTitular }}</strong>
                    , foi declinada devido às pendências abaixo relacionadas:
                  </p>
                  <br />
                  <p>
                    <strong>{{ motivoDeclinio }}</strong>
                  </p>
                  <br />
                  <p>
                    A proposta atual está anulada automaticamente, inviabilizando qualquer possibilidade de utilização,
                    ficando o potencial beneficiário responsável por qualquer utilização indevida deste.
                  </p>
                  <br />
                  <p>
                    Aproveitamos a oportunidade para informar que, permanecendo o interesse na adesão ao plano coletivo,
                    a orientação é de fazer o preenchimento de nova proposta.
                  </p>
                  <p>
                    Ressaltamos que todo dia 13, ou dia útil anterior, encerram-se as adesões para a vigência do dia 01
                    do mês subsequente ou todo dia 25, ou dia útil anterior, encerram-se as adesões para vigência do dia
                    15 do mês subsequente.
                  </p>
                  <br />
                  <p>
                    Sendo o que nos cumpria para o momento, ficamos à disposição para eventuais esclarecimentos e
                    aproveitamos o ensejo para renovar nossos protestos de elevada estima e distinta consideração.
                  </p>
                  <br />
                  <p>Atenciosamente,</p>
                  <p><strong>DEPTO COMERCIAL</strong></p>
                </td>
              </tr>
              <tr>
                <td align="center" style="background-color: #407590; color: #ffffff; padding: 20px; font-size: 12px">
                  <p>Para dúvidas e sugestões, contate o seu Corretor.</p>
                  <p>Av. Valdemar Ferreira, 463 Butantã, São Paulo - SP CEP 05501-000</p>
                  <p>
                    <a
                      href="https://www.geia.com.br/"
                      target="_blank"
                      style="color: #ffffff; text-decoration: underline">
                      www.geia.com.br
                    </a>
                  </p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </section>
  <!-- Email Declinio da Proposta Portabilidade 48hs-->
  <section class="mb-5" *ngIf="mostrarEmailDeclinadoPortabilidade">
    <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
      Email de Declinio da Proposta de Portabilidade - Declinado
      {{ dataDeclinio }} às {{ horaDeclinio }}
    </h3>
    <div>
      <title>Proposta Cancelada</title>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap" rel="stylesheet" />
    </div>
    <div style="margin: 0; padding: 0">
      <table width="100%" cellpadding="0" cellspacing="0">
        <tr>
          <td align="center">
            <table
              cellpadding="0"
              cellspacing="0"
              style="background-color: #f2f2f2; padding: 20px; width: 100%; max-width: 600px">
              <tr>
                <td align="center" style="padding: 20px 0">
                  <img
                    src="https://geia.com.br/assets/app-assets/images/logo/logo-b-geia.png"
                    width="120"
                    alt="Logo Geia" />
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  class="em_blue1"
                  style="
                    font-size: 18px;
                    line-height: 20px;
                    color: #023341;
                    font-weight: normal;
                    letter-spacing: 0.1px;
                    text-align: justify;
                    padding: 2rem;
                  ">
                  A presente proposta foi declinada com fundamento no art. 5º, §2º, da Resolução Normativa nº 413, de 11
                  de novembro de 2016, editada pela Agência Nacional de Saúde Suplementar–ANS, que ao regulamentar a
                  contratação dos planos de saúde de forma eletrônica, dispôs sobre os prazos para conclusão da
                  contratação nesta modalidade. Importante frisar que o artigo mencionado acima dispõe que, caso o
                  processo não seja concluído em 48 horas corridas, contados do início da contratação, a proposta será
                  automaticamente declinada, ficando na base de dados da corretora os dados registrados, respeitando
                  toda a política de dados inerente à Lei nº 17.709/2018. Por fim, resta deixar claro que a não
                  conclusão de um processo de contratação não impedirá o início de um novo processo, apenas deve ficar
                  claro que as datas de inclusão e vigência respeitarão o calendário ofertado pela Operadora do plano a
                  ser contratado.
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </section>
  <!-- Email Declinio da Proposta 25 dias-->
  <section class="mb-5" *ngIf="mostrarEmailDeclinadoSumulaNovaAdesao">
    <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
      Email de Declinio da Proposta - Declinado
      {{ dataDeclinio }} às {{ horaDeclinio }}
    </h3>
    <div>
      <title>Proposta Cancelada</title>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap" rel="stylesheet" />
    </div>
    <div style="margin: 0; padding: 0">
      <table width="100%" cellpadding="0" cellspacing="0">
        <tr>
          <td align="center">
            <table
              cellpadding="0"
              cellspacing="0"
              style="background-color: #f2f2f2; padding: 20px; width: 100%; max-width: 600px">
              <tr>
                <td align="center" style="padding: 20px 0">
                  <img
                    src="https://geia.com.br/assets/app-assets/images/logo/logo-b-geia.png"
                    width="120"
                    alt="Logo Geia" />
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  class="em_blue1"
                  style="
                    font-size: 18px;
                    line-height: 20px;
                    color: #023341;
                    font-weight: normal;
                    letter-spacing: 0.1px;
                    text-align: justify;
                    padding: 2rem;
                  ">
                  A presente proposta foi declinada com fundamento no art. 5º, §2º, da Resolução Normativa nº 413, de 11
                  de novembro de 2016, editada pela Agência Nacional de Saúde Suplementar – ANS, que ao regulamentar a
                  contratação dos planos de saúde de forma eletrônica, dispôs sobre os prazos para conclusão da
                  contratação nesta modalidade. Importante frisar que o artigo mencionado acima dispõe que, caso o
                  processo não seja concluído em 25(vinte e cinco) dias corridos, contados do início da contratação, a
                  proposta será automaticamente declinada, ficando na base de dados da corretora os dados registrados,
                  respeitando toda a política de dados inerente à Lei nº 17.709/2018. Por fim, resta deixar claro que a
                  não conclusão de um processo de contratação não impedirá o início de um novo processo, apenas deve
                  ficar claro que as datas de inclusão e vigência respeitarão o calendário ofertado pela Operadora do
                  plano a ser contratado.
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </section>
</div>
